import { useEffect, useState } from 'react';

// Same breakpoint as the phone layouts in MainPage.css and ResumePage.css
const PHONE_QUERY = '(max-width: 768px)';

const useIsPhone = () => {
    const [isPhone, setIsPhone] = useState(() => window.matchMedia(PHONE_QUERY).matches);

    useEffect(() => {
        const query = window.matchMedia(PHONE_QUERY);
        const update = () => setIsPhone(query.matches);
        query.addEventListener('change', update);
        return () => query.removeEventListener('change', update);
    }, []);

    return isPhone;
};

export default useIsPhone;
